var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("form", { staticClass: "toolbar" }, [
      _c("fieldset", { staticClass: "toolbar__filters" }, [
        _c(
          "div",
          { staticClass: "flex-fix" },
          [
            _c("FormControlDatepicker", {
              attrs: { name: "fromDate", label: "From date" },
              model: {
                value: _vm.formData.fromDate,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "fromDate", $$v)
                },
                expression: "formData.fromDate",
              },
            }),
            _vm._v(" "),
            _c("FormControlDatepicker", {
              attrs: { name: "toDate", label: "To date" },
              model: {
                value: _vm.formData.toDate,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "toDate", $$v)
                },
                expression: "formData.toDate",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("fieldset", { staticClass: "toolbar__search" }, [
        _c("div", { staticClass: "flex-fix" }, [
          _vm.resultCount !== null
            ? _c("span", [
                _vm._v("Matches " + _vm._s(_vm.resultCount) + " insights"),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }